import { Flame, Settings, Home, ShieldCheck, Airplay, Wind, Thermometer, 
  Activity, AlertOctagon, BadgeCheck, NotebookText, HandHelping, User } from "lucide-react";

export const faqItems = [
  {
    id: "1",
    question: "Quels services offrez-vous ?",
    answer:
      "Nous offrons une vaste gamme de services résidentiels au Québec, incluant l’entretien des systèmes de chauffage, de ventilation et de climatisation (CVC), le nettoyage des conduits d’air et de ventilation, le ramonage de cheminées, le nettoyage des conduits de sécheuse et plus encore. Nous veillons à ce que vos systèmes soient correctement entretenus."
  },
  {
    id: "2",
    question: "Est-ce que le nettoyage des conduits enlève vraiment la poussière et les allergènes?",
    answer:
      "Oui, le nettoyage élimine la poussière, les allergènes et les débris accumulés, ce qui améliore la qualité de l’air dans votre maison.",
  },
  {
    id: "3",
    question: "Combien de temps dure un nettoyage de conduits de ventilation ?",
    answer:
      "En moyenne, le service dure entre 2 et 4 heures selon la taille de la maison et l’état des conduits.",
  },
  {
    id: "4",
    question: "Est-ce que vos services aident à réduire les risques d’incendie ? ",
    answer:
      "Oui, surtout le nettoyage des conduits de sécheuse et le ramonage de cheminée, qui sont essentiels pour prévenir les incendies.",
  },
  {
    id: "5",
    question: "Pourquoi est-il important de nettoyer le conduit de sécheuse ? ",
    answer:
      "Un conduit de sécheuse obstrué peut causer des incendies et réduire l’efficacité de votre appareil. Le nettoyage assure sécurité et performance.",
  },
  {
    id: "6",
    question: "Comment savoir si mon conduit de sécheuse est bloqué ? ",
    answer:
      " Voici les signes : Vos vêtements prennent plus de temps à sécher, la sécheuse devient très chaude, il y a une accumulation de charpie et une odeur de brûlé.",
  },
  {
    id: "7",
    question: "À quelle fréquence dois-je faire nettoyer mon climatiseur (murale ou centrale) ? ",
    answer:
      "Il est recommandé de faire un nettoyage au moins 1 fois par année, idéalement avant l’été.",
  },
  {
    id: "8",
    question: "Est-ce que le nettoyage de climatiseur enlève la moisissure et les bactéries ? ",
    answer:
      "Oui, un nettoyage en profondeur permet d’éliminer la moisissure, les bactéries et les mauvaises odeurs.",
  },
  {
    id: "9",
    question: "Pourquoi le ramonage de cheminée est-il nécessaire chaque année ?",
    answer:
      "Le ramonage enlève la créosote, une substance inflammable, et réduit les risques de feu de cheminée tout en assurant une bonne ventilation.",
  },
  {
    id: "10",
    question: "Est-ce que le nettoyage améliore vraiment la performance et réduit les coûts d’énergie ? ",
    answer:
      "Oui, des systèmes propres fonctionnent plus efficacement, ce qui réduit la consommation d’énergie et prolonge la durée de vie de vos équipements.",
  },
];



export const ventilationServices = [
  {
    icon: HandHelping,
    title: "Un service humain et accessible",
    description:
    " Un technicien qui vous parle simplement, sans jargon technique. Facile à joindre, facile à comprendre. ",
  },
  {
    icon: NotebookText,
    title: "Explications claires à chaque étape",
    description:
    "Vous savez toujours ce qui est fait, pourquoi c’est fait et comment le processus se déroule.",
  },
  {
    icon: BadgeCheck,
    title: "Résultats concrets et vérifiables ",
    description:
    "Photos avant/après, air plus sain, maison plus propre : ils nous ont tout laissé faire.",
  },
];


export const dryerServices = [
  {
    icon: User,
    title: "Mathilde Haye",
    description:
      "L’équipe a fait un travail incroyable pour nettoyer nos conduits d’air et de sécheuse. Notre maison est plus sécuritaire et l’air est beaucoup plus frais !",
  },
  {
    icon: User,
    title: "Nathan Laviolette",
    description:
      "J’étais inquiet des risques d’incendie dans mon conduit de sécheuse. Leur service professionnel m’a vraiment rassuré et a amélioré la circulation d’air.",
  },
  {
    icon: User,
    title: "Guy Léonard",
    description:
      "Service excellent du début à la fin ! Nos conduits et notre cheminée sont impeccables, et la différence de qualité d’air est immédiate.",
  },
  ];
  
  
  export const chimneyServices = [
    {
      icon: AlertOctagon,
      title: "Chimneys & Fireplaces",
      description:
      "We service all types of chimneys and fireplace systems, from masonry to modern installations.",
    },
    {
      icon: Activity,
      title: "Removes Soot & Creosote",
      description:
      "Creosote is highly flammable. We remove all dangerous buildup thoroughly and safely.",
    },
    {
      icon: ShieldCheck,
      title: "Safety & Optimal Draft",
      description:
      "Ensures proper airflow while reducing fire risks and improving overall chimney performance.",
    },
  ];

  // ===========!!!!!!?????????==============
  
  // this is my history as developer who developed this project, if u get chance to modify this project please connect me f.uwimpuhwe@alustudent.com
  // to appreciate the work
  
  // export const workHistory = [
  //   {
  //     period: "2022",
  //     title: "Started Coding Journey",
  //     role: "Self-Taught Developer",
  //     description:
  //       "Started learning programming and web development, focusing on JavaScript and building small projects to understand core development concepts.",
  //   },
  //   {
  //     period: "2023",
  //     title: "Hackathon Experience",
  //     role: "Hackathon Participant",
  //     description:
  //       "Participated in Hack With Me Rwanda, Africa's talking and HackNoel hackathons, collaborating with students to build applications and improve teamwork and coding speed.",
  //   },
  //   {
  //     period: "2024",
  //     title: "Full Stack Developer",
  //     role: "Project Builder",
  //     description:
  //       "Built multiple projects including React Native apps, Next.js systems, backend APIs, and real-world web applications.",
  //   },
  //   {
  //     period: "Now",
  //     title: "College Developer",
  //     role: "Full Stack & Mobile Developer",
  //     description:
  //       "Currently studying in college while continuing to build scalable web and mobile applications using modern technologies.",
  //   },
  // ];